export default "__VITE_ASSET__e79ff7b6__"